export abstract class View {
  constructor(protected readonly element: HTMLElement) {}
}
